import React, { useContext } from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useQuery } from "@tanstack/react-query"
import {
  ChevronRight,
  CreditCard,
  Globe,
  LogOut,
  Monitor,
  Moon,
  Sun,
} from "react-feather"

import MobileHeader from "../components/MobileHeader"
import useMobileSections from "../useMobileSections"
import { AuthActions, AuthContext } from "../../contexts/auth/AuthContext"
import { ThemeActions, ThemeContext, ThemeType } from "../../contexts/ThemeContex"
import { GET_MY_SUBSCRIPTION } from "../../pages/subscription/queries"
import i18n from "../../services/i18n"
import { num } from "../format"

const LANGS = [
  { code: "uz", label: "O'zbekcha" },
  { code: "ru", label: "Русский" },
  { code: "en", label: "English" },
]

/**
 * "Yana" sahifasi — pastki menyuga sig'magan bo'limlar va sozlamalar.
 *
 * Ro'yxat foydalanuvchining huquqlariga qarab tuziladi: ruxsat
 * berilmagan bo'lim bu yerda ham ko'rinmaydi.
 */
export default function MobileMore() {
  const { t } = useTranslation()
  const history = useHistory()
  const { sections } = useMobileSections()
  const { authState, authDispatch } = useContext(AuthContext)
  const { themeState, themeDispatch } = useContext(ThemeContext)

  const isDark = themeState.currentTheme === "dark"

  const { data: sub } = useQuery(["SUBSCRIPTION_MY"], GET_MY_SUBSCRIPTION, {
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  return (
    <div className="mb-page">
      <MobileHeader title={t("mobMore")} />

      <div className="mb-body">
        {/* Obuna holati — muddat yaqinlashsa ko'rinadi */}
        {sub?.applicable && (sub.blocked || sub.showWarning) && (
          <div className={`mb-sub-warn${sub.blocked ? " mb-sub-warn--danger" : ""}`}>
            <CreditCard size={18} />
            <div>
              <div className="mb-sub-warn-title">
                {sub.blocked ? t("subBlockedMsg") : t("subMyStatus")}
              </div>
              <div className="mb-sub-warn-note">
                {sub.paidUntil && !sub.blocked
                  ? `${t("subDaysLeft")}: ${sub.daysLeft}`
                  : ""}
                {sub.periodPrice > 0
                  ? ` · ${num(sub.periodPrice)} ${sub.currency}`
                  : ""}
              </div>
            </div>
          </div>
        )}

        {/* Bo'limlar */}
        <div className="mb-group">
          <div className="mb-group-title">{t("mobSections")}</div>
          {sections.length === 0 ? (
            <div className="mb-empty">{t("mobNoSections")}</div>
          ) : (
            sections.map((s) => (
              <button
                key={s.code}
                type="button"
                className="mb-row"
                onClick={() => history.push(`/m/${s.code}`)}
              >
                <span>{t(s.labelKey)}</span>
                <ChevronRight size={17} />
              </button>
            ))
          )}
        </div>

        {/* Sozlamalar */}
        <div className="mb-group">
          <div className="mb-group-title">{t("settings")}</div>

          <button
            type="button"
            className="mb-row"
            onClick={() =>
              themeDispatch({
                type: ThemeActions.ChangeTheme,
                payload: {
                  currentTheme: isDark ? ThemeType.Default : ThemeType.Dark,
                },
              })
            }
          >
            <span>
              {isDark ? <Sun size={16} /> : <Moon size={16} />} {t("theme")}
            </span>
            <span className="mb-row-value">{isDark ? t("dark") : t("light")}</span>
          </button>

          <div className="mb-langs">
            <span className="mb-langs-label">
              <Globe size={16} /> {t("language")}
            </span>
            <div className="mb-langs-list">
              {LANGS.map((l) => (
                <button
                  key={l.code}
                  type="button"
                  className={i18n.language === l.code ? "mb-lang mb-lang--active" : "mb-lang"}
                  onClick={() => {
                    i18n.changeLanguage(l.code)
                    localStorage.setItem("i18nextLng", l.code)
                    window.location.reload()
                  }}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <button type="button" className="mb-row" onClick={() => history.push("/")}>
            <span>
              <Monitor size={16} /> {t("mobDesktop")}
            </span>
            <ChevronRight size={17} />
          </button>
        </div>

        {/* Hisob */}
        <div className="mb-group">
          <div className="mb-group-title">{t("account")}</div>
          <div className="mb-account">
            <div className="mb-account-name">{authState.user?.userName || "—"}</div>
            <div className="mb-account-mail">{authState.user?.email || ""}</div>
          </div>
          <button
            type="button"
            className="mb-row mb-row--danger"
            onClick={() => authDispatch({ type: AuthActions.SING_OUT })}
          >
            <span>
              <LogOut size={16} /> {t("logout")}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
